
// packages
import React, { useState } from 'react';
import { Box, TextField, Typography, Stack, Button } from '@mui/material'
import { useMediaQuery } from '@mui/material';

// local
import reserveDate from '../helpers/reserveDate';
import formatExamDate from '../utilities/formatExamDate';

const CalendarEventModal = ({date, handleClose, setSuccess=null, setDisplayDate=null, extraClose=null, refreshHook=null}) => {
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // DEFINITIONS
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const isMobile = useMediaQuery("(max-width:600px)");
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [maxParticipants, setMaxParticipants] = useState(0);

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // STYLES 
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        maxWidth: '95vw',
        minWidth:'75vw',
        maxHeight: '95vh',
        overflowY: 'auto',
        bgcolor: 'background.paper',
        borderRadius: 4,
        boxShadow: 24,
        p: 4,
    }
    const mobileModalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: '65vw',
        bgcolor: 'background.paper',
        borderRadius: 4,
        boxShadow: 24,
        p: 4,
    }

    return (
        <Box sx={!isMobile ? (modalStyle) : (mobileModalStyle)}>
            <Typography id="modal-modal-title" variant="h6" component="h2" sx={{fontWeight:600}}>
            Set Exam Date
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 0, mb:4 }}>
            Set a testing time slot for {formatExamDate(date)}
            </Typography>
            <Stack spacing={2} sx={{ mb: 2 }}>
                <TextField
                label="Start Time"
                type="time"
                value={startTime}
                onChange={(e) => setStartTime(e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
                />
                <TextField
                label="End Time"
                type="time"
                value={endTime}
                onChange={(e) => setEndTime(e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
                />
                <TextField
                label="Max Participants"
                type="number"
                value={maxParticipants}
                onChange={(e) => setMaxParticipants(e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
                />
            </Stack>
            <Stack direction={'row'} sx={{p:0, justifyContent:'space-between'}}>
                <Button variant='outlined' sx={{}} onClick={() => handleClose()}>Cancel</Button>
                <Button variant='contained' sx ={{borderTopLeftRadius:0,borderTopRightRadius:0}} onClick={() => {
                    handleClose();
                    if (extraClose) extraClose();
                    reserveDate(date, startTime, endTime, maxParticipants, setSuccess, setDisplayDate, refreshHook)
                }}>
                    Confirm
                </Button>
            </Stack>
        </Box>
    );
}

export default CalendarEventModal;